<!--
 * @Author       : 四川华西绿舍建材有限公司
 * @Date         : 2024-07-05 13:12:44
 * @LastEditTime : 2024-07-05 15:00:33
 * @LastEditors  : yangxr
 * @Description  : 在产信息
 * @FilePath     : \icps_fb\src\views\platform\ICPS\smart\schedul\productInfo.vue
-->
<template>
  <div class="pages_content table">
    <el-container>
      <el-header>
        <breaDcrumb />
      </el-header>
      <el-main style="display: flex">
        <div>
          <el-collapse-transition>
            <div v-show="showCardNav">
              <div class="search">
                <span style="margin-left: 24px">
                  <span style="margin-right: 12px">站点</span>
                  <el-select ref="selection" v-model="tableParam.productionSiteId" filterable @change="queryLineByStation" >
                    <el-option v-for="item in stationList" :key="item.id" :label="item.name" :value="item.id"></el-option>
                  </el-select>
                </span>
                <span style="margin-right: 24px">
                  <span style="margin-right: 12px">生产线</span>
                  <el-select v-model="tableParam.lineIds" style="width: 350px" multiple placeholder="请选择" @change="getStationTaskList">
                    <el-option v-for="(item, index) in lineList" :key="index" :label="item.name" :value="item.id"></el-option>
                  </el-select>
                </span>
                <el-button icon="el-icon-search" size="medium" class="bottom_all" @click="(tableParam.page = 1), getStationTaskList()">查 询</el-button>
                <el-button size="medium" class="bottom_all_two" style="margin-left: 12px" @click="init()">重 置</el-button>
              </div>
            </div>
          </el-collapse-transition>
          <div class="hr"></div>
          <div class="card">
            <div v-loading="tableLoading" class="card_info" :style="style">
              <el-table :header-cell-style="{ background: '#f3f6f9' }" :cell-style="{ borderRight: 'none' }" border stripe style="width: 100%" :data="tableData" tooltip-effect="dark">
                <template v-for="(item, index2) in table">
                  <el-table-column v-if="item.status" :key="index2" :label="item.label" align="center" :width="item.width">
                    <template slot-scope="scope">
                      <span>{{ scope.row[item.prop] }}</span>
                    </template>
                  </el-table-column>
                </template>
              </el-table>
            </div>
          </div>
        </div>
      </el-main>
    </el-container>
  </div>
</template>

<script>
import mixin from "@/mixins/ICPSmixin.js";
import { getUserAutList } from "@/api/common.js";
import { getUserInfo } from "@/utils/auth";
import { queryLineByStation, queryStationTaskList } from "@/api/smart/productTransport_outside.js";
// import { getUserInfo } from "@/utils/auth.js";
export default {
  mixins: [mixin],
  data() {
    return {
      table: [
        { label: "生产线", prop: "proLine", status: true, width: "80" },
        { label: " 车辆", prop: "carNo", status: true, width: "80" },
        { label: "工程项目", prop: "engineeringName", status: true, width: "auto" },
        { label: "产品名称", prop: "strengthGrade", status: true, width: "80" },
        { label: "浇筑部位", prop: "structuralParts", status: true, width: "130" },
        { label: "浇筑方式", prop: "pouringMethod", status: true, width: "auto" },
        { label: "票面量", prop: "faceValue", status: true, width: "70" },
        { label: "生产方量", prop: "proNum", status: true, width: "70" },
        { label: "创建时间", prop: "createTime", status: true, width: "135" },
      ],
      tableData: [],
      lineList: [],
      stationList: [],
      UserInfo: "",
      pagesType: 0,
    };
  },
  watch: {},
  async created() {
    this.UserInfo = await getUserInfo();
    this.stationList = await getUserAutList(true);
    this.init();
    this.queryLineByStation();
    // this.tableParam.productionSite = await getUserInfo()?.pointIds[0];
  },
  methods: {
    queryLineByStation() {
      //获取生产线
      queryLineByStation({ stationId: this.tableParam.productionSiteId }).then(res => {
        if (res.code == 1001) {
          this.lineList = res.data;
          this.tableParam.lineIds = [];
          //默认选择全部站点
          res.data.forEach(item => {
            this.tableParam.lineIds.push(item.id);
          });
          this.getStationTaskList();
        }
      });
    },
    getStationTaskList() {
      let _this = this;
      queryStationTaskList(this.tableParam).then(res => {
        if (res.code == 1001) {
          _this.tableData = res.data;
        }
      });
    },
    sizeChange(value) {
      this.tableParam.pageSize = value;
      this.getStationTaskList();
    },
    /*重置数据,此方法必须存在，并且方发只重置条件*/
    init() {
      this.tableParam = { ...this.tableParam, lineIds: [], productionSiteId: "" };
      if (this.UserInfo.pointIds.length > 0) {
        this.tableParam.productionSiteId = this.UserInfo.pointIds[0];
      } else {
        this.tableParam.productionSiteId = this.stationList[0].id;
      }
    },
  },
};
</script>

<style lang="scss" scoped>
.el-input,
.el-select {
  width: 240px;
}
.table_link {
  margin: 0 10px;
  color: $bg_color;
  cursor: pointer;
}

.table_link:hover {
  opacity: 0.8;
}
</style>
